import React from 'react';
import { Stars } from '@catalogo/theme-stars';
import { formatDate } from '@catalogo/ui-americanas-desktop-missing-reviews/src/helpers';
import { Card } from '../../molecules';
import { Image, ProductName } from '../../atoms';
import { ContainerDetails, Title, DeliveryDate } from './Styled';

interface CardReviewProps {
  srcImg: string;
  apiDate: string;
  productId?: number;
  skuId?: number;
  deliveryId?: number;
  orderId?: number;
  productName: string;
  dispatchMetrics: any;
}

const CardReview = (props: CardReviewProps) => {
  const { srcImg, apiDate, productId, skuId, deliveryId, productName, orderId, dispatchMetrics } = props;
  const sentenceDate = formatDate(apiDate);

  return (
    <a
      onClick={() =>
        dispatchMetrics('event:track', {
          category: 'missing-review',
          action: 'missingReviewClick',
          label: 'review-placement-key',
        })
      }
      href={`/avaliacao/${productId}?skuId=${skuId}&deliveryId=${deliveryId}&orderId=${orderId}&chave=tc_hm_dt_1__acom_atalho_review`}
    >
      <Card shadow={true}>
        <>
          <Image src={srcImg} width="115px" />
          <ContainerDetails>
            <Stars rating={0} size={14} gapBetweenStars={-1} />
            <Title>avalie sua compra :)</Title>
            <ProductName nameProduct={productName} />
            <DeliveryDate>{sentenceDate}</DeliveryDate>
          </ContainerDetails>
        </>
      </Card>
    </a>
  );
};

export { CardReview };
export default CardReview;
